/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from 'react';

import {service as FunderService} from '../../../../Services/FunderService';
import {useFetchServiceModel} from "../../../../Hooks/ServiceHooks";

/**
 * "The funder {name}", degrading to "A funder" when the name is not available.
 *
 * Funders are searched rather than cached, so unlike the other reference lookups in the feed there
 * is no cache for a facts supplier to read synchronously — the name arrives from a fetch, which is
 * why this is a node in the subject instead. Being a node is what makes that legal: it runs its own
 * hooks where it renders, not where the facts were built.
 *
 * The activity carries only a funderId, so the name is the one fact that can go missing. The line
 * degrades namelessly rather than being withheld, because this type rendered nothing at all before
 * it joined the grammar and "a funder was removed" is worth more than silence.
 */
export const FunderSubject = props => {
    const {FunderId} = props;

    const funder = useFetchServiceModel(FunderService, FunderId);
    const name = FunderService.GetTitle(funder);

    return name ? <>The funder {name}</> : <>A funder</>;
};
